export default "/images/404-footer-mobile.svg?2895a6de669f4d51e26677bffd82ba63";